export enum CmsStatus {
  Unpublished = 1,
  Published = 2,
  Scheduled = 3,
  PublishedAndUnpublishedVersions = 4,
}
